import React from 'react';
import { Data } from '../../types/data-providers';
import { useData, dataFromDataset } from './DataProviderCache';
import * as ChartManager from '../domain/chart-manager';
import { useAuthHelper } from '../../components/AuthContextProvider';
import { HumidityGraphData } from '../../types/device';

type ContextState = Data<HumidityGraphData>;
const Context = React.createContext<ContextState | null>(null);

function useHumidityGraphDetails(): ContextState {

    const contextState = React.useContext(Context);
    if (contextState === null) {
        throw new Error('useHumidityGraphDetails  details must be used within a Humidity Graph');
    }

    return contextState;
};

const HumidityGraphDataProvider: React.FC<{ deviceId: string }> = (props) => {

    const authHelper = useAuthHelper();
    const { dataset } = useData({
        cacheKey: 'humidity-graph',
        id: props.deviceId,
        dataFn: React.useCallback(() => ChartManager.getHumidityGraphProperties(authHelper, props.deviceId), [
            authHelper,
            props.deviceId,
        ])
    });
    const humidityGraphData = dataFromDataset(dataset);
  
    return <Context.Provider value={humidityGraphData}>{props.children}</Context.Provider>;
};
const TesthumidityGraphDataProvider: React.FC<{ value: ContextState }> = (props) => (
    <Context.Provider value={props.value}>{props.children}</Context.Provider>
);

export { HumidityGraphDataProvider, TesthumidityGraphDataProvider, useHumidityGraphDetails };
